import { useMemo } from 'react';
import { useForm } from 'react-hook-form';

import { useDTicketSubscription } from '@mopla/business-logic';
import {
	calculateSubscriptionPauseDates,
	getPauseDatesForInfoMessage,
	ISubscriptionPauseFormValues,
	TSubscriptionPauseDuration,
} from '@mopla/utils';

export const useDTicketSubscriptionPauseForm = () => {
	const { subscription } = useDTicketSubscription();
	const {
		control,
		handleSubmit,
		watch,
		formState: { isSubmitting },
	} = useForm<ISubscriptionPauseFormValues>({
		defaultValues: {
			duration: null,
		},
	});

	const selectedDuration = watch('duration');

	// Cancellation and pause effective dates can be used interchangeably
	// TODO: DTicket 2.0 – rename when BE switches to a generic name
	const nextCancellationEffectiveDate =
		subscription?.nextCancellationEffectiveDate
			? subscription.nextCancellationEffectiveDate
			: null;

	const pauseDates = useMemo(() => {
		if (!selectedDuration || !nextCancellationEffectiveDate) return null;

		return calculateSubscriptionPauseDates(
			parseInt(selectedDuration, 10),
			nextCancellationEffectiveDate
		);
	}, [selectedDuration, nextCancellationEffectiveDate]);

	const pauseDatesForInfoMessage = getPauseDatesForInfoMessage();

	const onSubmit = (
		callback: (duration: TSubscriptionPauseDuration) => void
	) => {
		return handleSubmit(({ duration }) => {
			if (!duration) return;
			callback(duration);
		});
	};

	return {
		control,
		selectedDuration,
		pauseDates,
		pauseDatesForInfoMessage,
		isSubmitting,
		onSubmit,
	};
};
